import { useState, useEffect } from "react"
import { IScoreVeles, ScoreVelesKeys } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useUIService } from "../../../../../../../use-cases/ui"
import { Autocomplete, Grid, TextField } from "@mui/material"
import { scoreDescriptionToLabel } from "../../../detalhes-do-projeto/filtros/score"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteScore = () => {
    // Redux State
    const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Local State
    const [selectedScoreVeles, setSelectedScoreVeles] = useState<IScoreVeles[]>([])

    // Hooks
    const { syncFilterWithForm, removeFilterFromForm, resetSelectedFilter } = useRecortesExtracaoService()
    const { setAlert } = useUIService()

    // Effects
    useEffect(() => {
        const scoresSelecionados = editRecorteExtracaoForm.fields.Filtros?.scoreVeles || [];

        if (scoresSelecionados.length > 0) {
            setSelectedScoreVeles(scoresSelecionados);
        } else {
            setSelectedScoreVeles([]);
        }
    }, [editRecorteExtracaoForm.fields.Filtros?.scoreVeles]);

    // Filter options to show only non-selected scores
    const filteredScoreVeles = ScoreVelesKeys.filter((score: IScoreVeles) =>
        !selectedScoreVeles.includes(score)
    );

    const handleScoreVelesSelectionChange = (value: IScoreVeles[]) => {
        setSelectedScoreVeles(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'scoreVeles',
                value: value,
                formType: 'edit'
            });
        } else {
            removeFilterFromForm({
                filtro: 'scoreVeles',
                formType: 'edit'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredScoreVeles}
                    value={selectedScoreVeles}
                    getOptionLabel={(option) => scoreDescriptionToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    onChange={(event, value) => {
                        handleScoreVelesSelectionChange(value);
                    }}
                    noOptionsText='Nenhum score encontrado'
                    filterSelectedOptions={true}
                    disableCloseOnSelect
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Opções"
                        />
                    )}
                />
            </Grid>
        </>
    )
}